import React, {useEffect, useRef, useState} from 'react';
import TrackList from "../../UI/TrackList/TrackList";
import  "./PlaylistItem.css"
import {Player as pl, Player} from "../../../classes/Player";
import usePlayerState from "../../../hooks/usePlayerState";
import {ChevronLeft, Heart, ListMusic, MoreHorizontal, Pause, Play} from "lucide-react";
import axios from "axios";
import {useSession} from "../../../AppContext";
import {useLocation, useNavigate, useParams} from "react-router-dom";


const getWordForm = (count) => {
    const lastTwo = count % 100;
    const last = count % 10;

    if (lastTwo >= 11 && lastTwo <= 14) {
        return "треков";
    }
    if (last === 1) {
        return "трек";
    }
    if (last >= 2 && last <= 4) {
        return "трека";
    }
    return "треков";
};

const getSum = (Tracks) => {
    const totalSeconds = Tracks.reduce(
        (sum, track) => sum + (track.duration || 0),
        0
    );

    const m = Math.floor(totalSeconds / 60);
    const s = Math.floor(totalSeconds % 60).toString().padStart(2, "0");

    return `${m} мин ${s} сек`;
};


const PlaylistItem = ({ setCurrentTrack: setCurrentTrackProp, Tracks: externalTracks, creatorId: externalCreatorId, title: externalTitle, type: externalType, isFavorite: externalIsFavorite, toFavorite: externalToFavorite, AutName: externalAutName, year: externalYear, image: externalImage, RollBack: externalRollBack }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = useParams();
    const state = location.state || {};

    const [internalTracks, setInternalTracks] = useState([]);

    useEffect(() => {
        if (!state.tracks && !externalTracks && id) {
            axios.get(`/api/users/${id}/favoriteTracks`)
                .then(res => setInternalTracks(res.data));
        }
    }, [id]);

    const Tracks        = externalTracks      ?? state.tracks      ?? internalTracks;
    const title         = externalTitle       ?? state.title       ?? '';
    const AutName       = externalAutName     ?? state.AutName     ?? '';
    const image         = externalImage       ?? state.image       ?? null;
    const type          = externalType        ?? state.type        ?? '';
    const year          = externalYear        ?? state.year        ?? '';
    const creatorId     = externalCreatorId   ?? state.creatorId   ?? null;
    const isFavorite    = externalIsFavorite  ?? state.isFavorite  ?? false;
    const toFavorite    = externalToFavorite  ?? state.toFavorite  ?? (() => {});
    const setCurrentTrack = setCurrentTrackProp ?? (() => {});
    const RollBack      = externalRollBack    ?? (() => navigate(-1));

    const [imgError, setImgError] = useState(false);
    const session = useSession();
    const player = useRef(pl.getInstance()).current
    const isPlaying = usePlayerState(player, Tracks);

    const handlePlay = () => {
        const queue = player.queue;
        const isSameQueue = queue.length === Tracks.length &&
            queue.every((t, i) => t.id === Tracks[i]?.id);

        if (!isSameQueue) {
            player.setTrack(Tracks[0], Tracks);
            setCurrentTrack(Tracks[0]);
        } else {
            if (player.isPlaying()) {
                player.pause();
            } else {
                player.play();
            }
        }
    };

    return (
        <div className={"liked"}>
            <button className="music-back" onClick={() => RollBack()}>
                <ChevronLeft size={20} />
            </button>
            <div className="liked-header">
                <div className="playlist-logo-wrapper">
                    {image && !imgError ? (
                        <img src={image} className="playlist-logo" alt="logo" onError={() => setImgError(true)} />
                    ) : (
                        <ListMusic size={64} color="#b4b2a9" />
                    )}
                </div>
                <div className="liked-header-info">
                    <p>{type}</p>
                    <h1>{title}</h1>
                    <p className="liked-composer">
                        {type === "Альбом" ? `${AutName} · ${year}` : `Составитель: ${AutName}`}
                    </p>
                    <div className="liked-count-time">
                        {type === "Альбом" && Tracks.length === 1 ? (
                            <div>сингл</div>
                        ) : (
                            <>
                                <div>{Tracks.length} {getWordForm(Tracks.length)}</div>
                                <span>·</span>
                                <div>{getSum(Tracks)}</div>
                            </>
                        )}
                    </div>
                    <div className="liked-buttons-action">
                        <button
                            className="liked-play-btn"
                            onClick={handlePlay}
                            disabled={Tracks.length === 0}
                        >
                            {isPlaying? <Pause size={18}/> : <Play size={18}/>}
                            <span>Слушать</span>
                        </button>
                        {session.id !== creatorId &&
                            <button
                                className="liked-props-btn"
                                onClick={toFavorite}
                            >
                                <Heart size={18} fill={isFavorite ? 'white' : 'none'}/>
                            </button>
                        }
                        <button className="liked-props-btn">
                            <MoreHorizontal size={18}/>
                        </button>
                    </div>
                </div>
            </div>

            <TrackList tracks={Tracks} setCurrentTrack={setCurrentTrack}/>
        </div>
    );
};

export default PlaylistItem;